import React, { useMemo } from 'react'
import makeStyles from '@material-ui/styles/makeStyles'
import { PersonRef } from 'civic-champs-shared/common/types'
import { Activity } from 'champion/utils/interface'
import { useCurrentOrg } from 'auth/hooks'
import { ProfileActivitiesTable } from 'tracking/activity/components/ProfileActivitiesTable'

const useStyles = makeStyles({
  container: {
    marginTop: '32px',
    display: 'flex',
    flexDirection: 'column',
  },
})

export const ProfileActivities = ({
  activities,
  person,
  reloadProfile,
}: {
  activities: Omit<Activity, 'user' | 'organization'>[]
  person: PersonRef
  reloadProfile: () => void
}) => {
  const classes = useStyles()
  const organization = useCurrentOrg()
  const activitiesWithUser = useMemo(
    () =>
      activities.map(activity => ({
        ...activity,
        user: person,
        organization: { id: organization.id, name: organization.name },
      })),
    [activities, organization.id, organization.name, person],
  )

  return (
    <div className={classes.container}>
      <ProfileActivitiesTable activities={activitiesWithUser} person={person} reloadProfile={reloadProfile} />
    </div>
  )
}
